import React, { useEffect } from 'react';
import LoginForm from 'components/authentication/LoginForm';
import routes, { peltaskRoutes, peltaskAdminRoutes, pharmacyAdminRoutes, reportRoutes, Rout4MeRoutes, orderHistoryRoutes, patientRoutes, masterRoutes, MedpassRoutes, drugListRoute, Resources } from 'routes/siteMaps';
import SignInLayout from 'components/authentication/registration/SignInLayout';
import { useUnsavedChanges } from 'components/prescription/UnsavedChangesContext';
import { toast } from 'react-toastify';

const Login = () => {

  //cleanupactivity todo better way to right this
  const { setIsDirty } = useUnsavedChanges();
  setIsDirty(false);

  const sessionMessage = localStorage.getItem('session_message');
  localStorage.clear();
  if (sessionMessage) {
    localStorage.setItem('session_message', sessionMessage);
  }

  useEffect(() => {
    const pendingSessionMessage = localStorage.getItem('session_message');
    if (pendingSessionMessage) {
      toast.warning(pendingSessionMessage, {
        theme: 'colored'
      });
      localStorage.removeItem('session_message');
    }
  }, []);

  if (routes.includes(peltaskRoutes)) {
    const index = routes.indexOf(peltaskRoutes);
    routes.splice(index, 1);
  }

  if (routes.includes(peltaskAdminRoutes)) {
    const index = routes.indexOf(peltaskAdminRoutes);
    routes.splice(index, 1);
  }

  if (routes.includes(pharmacyAdminRoutes)) {
    const index = routes.indexOf(pharmacyAdminRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(Rout4MeRoutes)){
    const index = routes.indexOf(Rout4MeRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(patientRoutes)){
    const index = routes.indexOf(patientRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(masterRoutes)){
    const index = routes.indexOf(masterRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(reportRoutes)){
    const index = routes.indexOf(reportRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(orderHistoryRoutes)){
    const index = routes.indexOf(orderHistoryRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(MedpassRoutes)){
    const index = routes.indexOf(MedpassRoutes);
    routes.splice(index, 1);
  }
  if(routes.includes(Resources)){
    const index = routes.indexOf(Resources);
    routes.splice(index, 1);
  }


  return (
    <SignInLayout
      showFeatures
      footer={
        <div className="mym-auth-help">
          <p>
            For support, including login assistance or website issues, email{' '}
            <a href="mailto:support@mapyourmeds.com">support@mapyourmeds.com</a>.
          </p>
        </div>
      }
    >
      <LoginForm layout="split" hasLabel />
    </SignInLayout>
  );
};

export default Login;
